import React from 'react';
import Route from 'react-router/lib/Route';
import { requireViewableCustomReports, requireEditableCustomReports } from '../../../auth/routerHooks';
import CustomReport from './components/CustomReport';
import {
  NewCustomReportContainer as NewCustomReport,
  EditCustomReportContainer as EditCustomReport,
} from './components/EditCustomReport';

export const Routes = store => (
  <Route path="custom" name="reports.custom" >
    <Route path="new" component={NewCustomReport} onEnter={requireEditableCustomReports(store)} />
    <Route path=":id/edit" component={EditCustomReport} onEnter={requireEditableCustomReports(store)} />
    <Route path=":id" component={CustomReport} onEnter={requireViewableCustomReports(store)} />
  </Route>
);

export default Routes;
